/**
 * Loading component
 */
import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingProps {
  message?: string;
  fullScreen?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({ message, fullScreen = false }) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center gap-4',
      fullScreen && 'fixed inset-0 z-[9999] bg-background'
    )}
  >
    <Loader2 className="size-8 animate-spin text-muted-foreground" />
    {message && <p className="text-sm text-muted-foreground">{message}</p>}
  </div>
);
